import Vue from 'vue';
import axios from 'axios';

Vue.component('twitter-item', {
    data: function() {
        return {
            twitterFeed: [],
            loading: false,
            errored: false
        };
    },
    mounted() {
        window.twttr = (function(d, s, id) {
            const fjs = d.getElementsByTagName(s)[0],
                t = window.twttr || {};
            if (d.getElementById(id)) return t;
            const js = d.createElement(s);
            js.id = id;
            js.src = 'https://platform.twitter.com/widgets.js';
            fjs.parentNode.insertBefore(js, fjs);

            t._e = [];
            t.ready = function(f) {
                t._e.push(f);
            };

            return t;
        })(document, 'script', 'twitter-wjs');

        this.$nextTick(function() {
            this.getItems();
        });
    },
    methods: {
        getItems: function() {
            const self = this;
            self.loading = true;

            axios
                .get('/api/twitter/gettweets')
                .then(response => {
                    if (response.data.length) {
                        self.twitterFeed = response.data;
                    }
                })
                .catch(() => {
                    self.errored = true;
                    self.loading = false;
                })
                .finally(function() {
                    if (self.twitterFeed.length) {
                        self.addLinksToTweets();
                    }
                    self.loading = false;
                });
        },

        addLinksToTweets: function() {
            for (let i = 0; i < this.twitterFeed.length; i++) {
                let text = this.twitterFeed[i].Text;
                const matches = text.match(/(#\w*|@\w*|https:\/\/t.co\/\w*)/gm);

                if (matches != null) {
                    for (let j = 0; j < matches.length; j++) {
                        let rawMatch = matches[j].replace(
                            /(@)/,
                            'http://twitter.com/'
                        );

                        if (rawMatch === matches[j]) {
                            rawMatch = matches[j].replace(
                                /(#)/,
                                'http://twitter.com/hashtag/'
                            );
                        }

                        text = text.replace(
                            matches[j],
                            '<a href="' +
                                rawMatch +
                                '" target="_blank">' +
                                matches[j] +
                                '</a>'
                        );
                    }
                }

                const matchreadmore = text.match(
                    /… <a href="https:\/\/t.co\/\w*" target="_blank">https:\/\/t.co\/\w*<\/a>/gm
                );
                text = text.replace(matchreadmore, '…');

                this.twitterFeed[i].Text = text;
            }
        }
    }
});
